export default __webpack_public_path__ + "static/2-667db5ccdafa85ddc045ed125c37e581.jpeg";